/**
 * A single-location Google Maps embed for the property-detail page's
 * "Location" section. Uses Google's keyless `output=embed` mode — no Google
 * Maps API key or billing account required — since this only ever needs one
 * fixed pin, not custom markers or interactivity beyond what Google's own
 * embed already provides (pan/zoom, "Open in Google Maps").
 */
export function LocationMap({
  lng,
  lat,
  title,
}: {
  lng: number;
  lat: number;
  title: string;
}) {
  const src = `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;

  return (
    <iframe
      title={`Map showing the location of ${title}`}
      src={src}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      className="mt-4 aspect-[16/7] w-full rounded-lg border border-border"
      style={{ border: 0 }}
    />
  );
}
